import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-termsofuse',
  templateUrl: './termsofuse.component.html',
  styleUrls: ['./termsofuse.component.css']
})
export class TermsofuseComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
  }
  print() {

    var myvar = '<html>' +
      '' +
      '<head>' +
      '   ' +
      '</head>' +
      '<style>' +
      '    table.details {' +
      '    border: 2px solid #000;' +
      '    width: 100%' +
      '}' +
      '.pi_heading {' +
      '    text-align: center' +
      '}' +
      '.logo_heading {' +
      '    width: 100%' +
      '}' +
      '.logo_heading img {' +
      '    height: 30px' +
      '}' +
      '.logo_com img{' +
      '    float: left' +
      '}' +
      '.logo_prod img{' +
      '    float: right;' +
      '    margin-right: 40px;' +
      '    transform: scale(1.8);' +
      '}' +
      '.lg{' +
      '    width: 100%;' +
      '    padding: 20px' +
      '}' +
      '' +
      '.logo_com{' +
      '    width: 50%' +
      '}' +
      'body{' +
      '    padding-left: 15%;' +
      '    padding-right: 15%' +
      '}' +
      '.pi_heading2 {' +
      '    text-align: left' +
      '}' +
      '' +
      '' +
      'table.details {' +
      '    border-collapse: collapse;' +
      '    border: 2px solid black;' +
      '}' +
      '' +
      '.logo_prod, .logo_com {' +
      '    width: 50%;' +
      '}' +
      '' +
      '.pi_heading h5 {' +
      '    line-height: 30px;' +
      '    margin: 0px;' +
      '    font-size: 20px;' +
      '}' +
      ' table.details th, table.details td {' +
      '    border: 1px solid black;' +
      '}' +
      '.pi_heading1>td {' +
      '    padding: 3px;' +
      '    font-family: Roboto,Helvetica,Arial,sans-serif;' +
      ' }' +
      '' +
      ' .pi_heading1>td>h5 {' +
      '    margin: 0px;' +
      '}' +
      '' +
      '.pi_heading1>td>p {' +
      '    margin: 0px;' +
      '}' +
      '' +
      '.pi_heading1 td h4 {' +
      '    text-align: center' +
      '}' +
      '' +
      '' +
      '    @media print {' +
      '        .lg {' +
      '            width: 100%' +
      '        }' +
      '        body {' +
      '            padding-left: 0%;' +
      '            padding-right: 0%;' +
      '            font-family: \'Georgia\';' +
      '            width: 74mm;' +
      '            height: 105mm;' +
      '        }' +
      '        table.details {' +
      '            border: 2px solid #000;' +
      '            width: 100%;' +
      '            border-collapse: collapse;' +
      '        }' +
      '        .pi_heading {' +
      '            text-align: center' +
      '        }' +
      '        .pi_heading1>td {' +
      '            padding: 4px;' +
      '            font-family: Roboto, Helvetica, Arial, sans-serif;' +
      '        }' +
      '        .pi_heading h5 {' +
      '            line-height: 30px;' +
      '            margin: 0px;' +
      '            font-size: 20px;' +
      '        }' +
      '        .pi_heading h4 {' +
      '            text-align: left' +
      '        }' +
      '        .pi_heading1>td>h4 {' +
      '            text-align: left;' +
      '        }' +
      '        .pi_heading1>td>h4 {' +
      '            margin: 0px;' +
      '        }' +
      '        .pi_heading2 {' +
      '            text-align: left' +
      '        }' +
      '        .logo_heading {' +
      '            width: 100%' +
      '        }' +
      '        .logo_heading img {' +
      '            height: 30px' +
      '        }' +
      '        .logo_com img {' +
      '            float: left' +
      '        }' +
      '        .logo_prod img {' +
      '            float: right;' +
      '            margin-right: 40px;' +
      '            transform: scale(1.8);' +
      '        }' +
      '        .logo_prod,' +
      '        .logo_com {' +
      '            width: 50%' +
      '        }' +
      '' +
      '        /* table.details {' +
      '           ' +
      '        } */' +
      '        table.details th,' +
      '        table.details td {' +
      '            border: 1px solid black;' +
      '        }' +
      '        .pi_heading1>td>p {' +
      '            margin: 0px;' +
      '        }' +
      '' +
      '        .pi_heading1>td.order_row {' +
      '            width: 33.33333%;' +
      '        }' +
      '        @page {' +
      '            size: 74mm 105mm;' +
      '        }' +
      '    }' +
      '    table.details {' +
      '    border: 2px solid #000;' +
      '    width: 100%' +
      '}' +
      '.pi_heading {' +
      '    text-align: center' +
      '}' +
      '.logo_heading {' +
      '    width: 100%' +
      '}' +
      '.logo_heading img {' +
      '    height: 30px' +
      '}' +
      '.logo_com img{' +
      '    float: left' +
      '}' +
      '.logo_prod img{' +
      '    float: right;' +
      '    margin-right: 40px;' +
      '    transform: scale(1.8);' +
      '}' +
      '.lg{' +
      '    width: 100%;' +
      '    padding: 20px' +
      '}' +
      '' +
      '.logo_com{' +
      '    width: 50%' +
      '}' +
      'body{' +
      '    padding-left: 15%;' +
      '    padding-right: 15%' +
      '}' +
      '.pi_heading2 {' +
      '    text-align: left' +
      '}' +
      '' +
      '' +
      'table.details {' +
      '    border-collapse: collapse;' +
      '    border: 2px solid black;' +
      '}' +
      '' +
      '.logo_prod, .logo_com {' +
      '    width: 50%;' +
      '}' +
      '' +
      '.pi_heading h5 {' +
      '    line-height: 30px;' +
      '    margin: 0px;' +
      '    font-size: 20px;' +
      '}' +
      ' table.details th, table.details td {' +
      '    border: 1px solid black;' +
      '}' +
      '.pi_heading1>td {' +
      '    padding: 3px;' +
      '    font-family: Roboto,Helvetica,Arial,sans-serif;' +
      ' }' +
      '' +
      ' .pi_heading1>td>h5 {' +
      '    margin: 0px;' +
      '}' +
      '' +
      '.pi_heading1>td>p {' +
      '    margin: 0px;' +
      '}' +
      '' +
      '.pi_heading1 td h4 {' +
      '    text-align: center' +
      '}' +
      '' +
      '' +
      '    .pi_heading h4 {' +
      '        text-align: left' +
      '    }' +
      '' +
      '    .pi_heading1>td>h4 {' +
      '        text-align: left;' +
      '    }' +
      '' +
      '    body {' +
      '        width: 74mm;' +
      '        height: 105mm;' +
      '    }' +
      '' +
      '    @page {' +
      '        size: 74mm 105mm' +
      '    }' +
      '</style>' +
      '' +
      '<body>' +
      '    <div style="width: 75mm; height: 105mm; margin: auto; overflow: hidden;padding: 0px">' +
      '        <table class="details">' +
      '            <tbody>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="5" style="text-align: center">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAdEAAACbCAYAAAA9d6ElAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAClESURBVHhe7Z0HeBVV+v+Tm15ubnpvJIQ0ICFA6DX0IoQuSBcpAgZBaSJKsSOCSLMA64K44rI2dF0VXdeyKnYFxLburu7afq4iLqu/Of/3nZlzz0xmcpOg/p+V3/fzPN8nN+85c++dW85n5t65Z4KIdylfUN6iRHEhAFdRuC9nIhdMBlNk3S2PU6w8T3HrJ9OdIplNkfXlXDBpQ7EuUz9vUiIoknspsq2aCwEYQpF9t3PBJIXyEYXrL1NCKZIHKHIZt4ymSGopsr6JCyZZlE8o1uWs+SsllRKIOorsfzEXTDpSZP0gF0z4MXqdItvc0pYiWUpx6yOzkSLJpvzY9eF1kP153STW9eHnVsLrw8891z+gJFIkuyhymRoumEyjyPoVXAhALOU4RfZ3SwlFwtcn6zO4YNKXYl2mfp6iWOH/3frJ8PVJ+HZkvbH18VLeoVivq36KKRLr+vDjJuHHU9b5cZbw48/PA9cDvSfdMoESCH6c3ZaTOUaJoUj2U2SbdYyZS5F1fn1L+HUv6w9xwYTf9/z+53pz35MNvYbdcoQSQpE8RHHrJ8PjioTHG7c+MjxeSazrw+Mbj3OBsL4nL+KCCY+rsu6WQOvD47mEx3lZ5+cmEDmUf1C4L3vFymMUeT1uYW9J2GdufWTuoUjYk+xLrr/HhW8ogvIZJZoLAdhC4b6cmVwwGUmRdbe8SrHC4nbrJ2Md4PgJk/X1XDBpR7EuUz+fUiIpksMU2daNCwEYRZF9+Y0nSaecpnD9bxSrRJ+lyGXcMokiOZci67u5YJJL0SjW5az5DyWDEojLKLL/5Vww6UqRdesAzYMavwhlm1vaUyRrKW59ZO6gSPIobn1kmrI+vA6yP6+bxLo+/NxK+Dnn557rpyhJFAlvPMhleENJMo8i6xu4EACWzv9QZH+3tKZI+PpkfT4XTPgNbF2mfvhNaoX/d+snYx0Q+HZkvbH1iaP8i2K9rvopp0is68OPm4QfT1m3bqTx48/PA9cDvSfdMp0SCH6c3ZaT+ZLCGz2SRymyzbrRsYQi6/z6lvDrXtatAzS/7/n9z/Xmvicbeg27hQVtlQ7fB7d+MjyuSHi8cesjw+OVxLo+PL7xOBcI63tyBRdMeFyVdbcEWh8ezyU8zss6PzeByKfIvuwVK69QZJtb2FsS9plbHxnrjiB7kn3J9ZNcYJvyP3+nNCbRmyjySq0v8HMosu6WFylWjlLc+sn0oUh4S0fW13DBpJJiXaZ++EVhfcNa30D84g2EdaPg11wwSaPIjY73KVaJspjkMm6xvsDHU2T9Ni6Y8FbVvynW5azhJ6yxFzhvxcn+K7lg0oUi67yFJmGJ8tanbHNLFUXCeyJufWR2UiS8USA3OtzSlPXhdZD9rZ9EWNeHn1sJP+dyQPiKYpUob03KZQZxwYQ/7ZD167gQAJboPymyv1us0uHrk3XrVvVAinWZ+qm/4cn/u/WT4euT8O3IemPrwxKVA0JDKaNIrOvDj5uEH09Zt2618+PPzwPXA70n3TKVEgh+nN2Wk+GNQ6tEH6LItt5cMFlEkXXrnju/7mX9aS6Y8Pue3/9cb+57sqHXsFt4L8cqHb4Pbv1keFyRWDfU3WLdkLauD49vPM4FwvqetO65N7ZREGh9eDyX8Dgv6/zcBII31HlDhvuyV6y8QJHX4xb2loR95tZH5hGKhD3JvuQ6b6hBoi5AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUQJSNQJJGoPJKqARFUdEoVEIVECEnUCidoDiSogUVWHRCFRSJSARJ1AovZAogpIVNUhUUgUEiUgUSeQqD2QqAISVXVIFBKFRAlI1Akkag8kqoBEVR0ShUQhUQISdQKJ2gOJKiBRVYdEIVFIlIBEnUCi9kCiCkhU1SFRSBQSJSBRJ5CoPZCoAhJVdUgUEoVECUjUCSRqDySqgERVHRKFRCFRAhJ1AonaA4kqIFFVh0QhUUiUgESdQKL2QKIKSFTVIVFIFBIlIFEnkKg9kKgCElV1SBQShUSJ/zX/4RdDDBcCwAOkvFLrG2g0RdbdcoxiRd6BhtKfIrmUIuvXc8GkPcW6TP3wiyGKInmWItt6ciEAYymy70EumGRQZJ03PqwSfZki29xiHRAmU2R9HxdM+AVhXcYtmZRAXEmRfddywaQHRdaf54IJS/RfFNnmlo4UyTUUtz4y1o2OfIpbH2saWx9eB9mX101iXR9+biX8nMsNHU4yRXKIIuvDuWCykCLrN3MhACydQBs6nLYUCV+frNdxwWQYxbpM/fCgZkUOcg2Fr0/CtyPrja2Pj/I9xXpd9dOGIrGuDz9uEn48ZZ0fZwk//rIe6D3pllmUQPDj7LaczHcU3uiRWDd0+3HBZBlF1vn1LeHXvaxbN2r4fS93PjjNeU829Bp2y+cUq3Qa25DicUXC441bHxkeryT114fHuUBY35OruWDC46qsuyXQ+vB4LuFxXtb5uQlEC4rsy16x0tjOGntLYt2QdsufKBL2JPuS6xoX9lN4C+1XFB5QA3EBhftyrKLrRJF1t/AerJXtFLd+MtZBaARF1s/jgkkBxbpM/fD6hFMk6yiyrZQLAeAtRNl3CRdM4ikHKFy/nWJ9QVxLkcu4pRdFwi82Wec9bUkK5XcU63LW3EtJoARiHEX2t26ZllBkfT0XTMIouymyzS2FFMkkilsfmQUUyU+xPrwOsj+vm8S6PvzcSvg55+ee67+hWAdR3guQy1jftIMpsj6DCwFgCeylyP5u4T1wCV+frA/hggnv5ViXqZ/68uP/3frJWD8t4NuR9cbWh7eq76JYr6t+Glofftwk/HjKunVvix9/fh64Hug96ZYaSiD4frktJ8MbdFZp816mbLNuGPAnT7LOr28Jv+5l3bpHz+97fv9zvbnvyYZew27h2/BQJHwf3PrJWHcOeLxx6yPD45XEuj48vvE4Fwjre3IMF0x4XJV1twRaHx7PJTzOyzo/N4FIpdxH4b7sFSsbKfJ63MLekrDP3PrIWD8FZU/KMeZuLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAs9HeWRCRHRWUFVXUOavXYWGdBapZ9C0KyqI/eqKyO2dpmtbYDFwBObx6GM+2o19fYsXQLCGEdcq6s5pbxwQl0h/j8aTnRS/+F8HPbefsKP/zPWbdA/919xEAAP6/cNmoskNhnqBT3qKuJ8c8r/E0Xk3m0IbJvbq1jNuQEB30WGxE0Ckq6QkOizqVUVD6blBKq20D52y0zisbEBKlZ9PFoy4uz0k4mJkYzXPK6tcXEuk9lVlQ+nZaxYCbvJO2FuudfyR0W6GrJnS6lS4eDPMmHKxZtt86W06DTOyeybMX8XSUTU5Wv7nWKSBd4Y2EBbVtLmyR7D2YFK3PO2s8nuHRp4KiUp4q7jb+lrr7vrDOC2xj36U1U+Njwlxvv6lJK+9xcOlRwdNFunLvwg6tayoytpYWZJyIDvP4n++41PxT2YWlj6f3mjn38P+hjR0AwP9xHlw77rL8pEh9fkpfcTcx8kXNOsVgg7CA6oaVbmyV5RUhwY55Lm2JSy0QPcYv/gMNrgGnMzv55s7KsR1yDqf7jPvjGk+oCE3IOlUzZ+PNtDfU2DSZATmwYuDy4swY/Xoj4pJE36X7NxgtDSPEsZIJXXKc96uRZPWfU/8kEDZe2DSyV582KW/FRoS4Ls8JCY0QWeW9T9dt/j3PZ+1g7yV9tiR4w12XbWoy2vYWl7ytWacw9HPFeUXLSzLjToeGBLsuqycsRiS17f9m0IV/bkX/AwDA2cvzuxZf3r1lmn8A9LXq+sOoF4R1Dk1XSKDhK8dV3pfkjVKDp4cG/4hYnhj+BCczxUdyVYOtJzRSlA2+8LnXhXCd51TTbsm5oF/5P8L5esxlwqN8IiLG+wldPpGSEHsq0jJ4xybkiL5zb3yALp8Rf3t0ec2Aymz/9UV4E0XN0v3WOYBd+fzxWQN6FKf6l2tqsvvNfYn+unL0oUsnDmmXZ+sfFZcsgoOD36XLJxK9vFGh1j2tqKdYdu/L8+iyjX2X9r3lx0o0s00fseYDrR1dtnHVuLzlGV5737jkTP57Ijg46F1vhF2sYS27fzh453sQKQDg7OTA+umXdynMsA18TZEoCTT4wBUDl+cnKYEm5ZSLLqNm3RrUaS5PgM0TXHt2rZ7UeVTXVtcXpkbLsxSJsJhU0W3htq10HdZJsPk6Q9ZPqro/KtTo5wmJEHnVQ/6R3nXG6NXPfsTfDXoe3zqneFrvVku7lmT5bzcitVhM3/XiTLrcLIQ4mj9vYPlf+aJMUyX6py1Tr8r1eozlouJ/CIr28eTufAKBgMnqN8d6yio/2vFFWSPaJfOGgn6dsSn5ou3ASQ9Vj6jrMXbsWJ6Y3LN23vBBg9umPRUVpu5vbvfJn+2tt0Hy60tqxvtiw11vv4Fsbdsi6UOPubHjCY8WFWOW/e42TbOeNCDoH0/dOKlva12YesITskXV0Ol7x6/cwafe8vTqFRQ6f1j2yCGdCz4KNvt4PB5ROWLJMa3edQEAwC8aTfuTd06/zKsK02P9g6JMUySqaS9mzOjbyn8qsuTcjtqinc9aTzFm4/7La8aX5/p+oIt6/6z2Q8V1R05bzxIU9NkTl9T0LFZ7xK16z/zoNU2znuXDzzv3r5vXpTDF37f7uSs/p4Haes7SRtl8Qe8HfFGh/uvgNFWit9bV7IsONfaWW/Y47wfaALCeL7NZ0LKhN8zseCA6zJByZFyWmLT2rofcPqbmjZfZ/bKfCTM/Og+JzRR9VvzWeraWZqN9c6DPsIqcL1h8wUFhosXAuS/T7fBZhWzcOLvHk7TVo99umC9bDLnynvpnhdIR4mD+lF4F/F2u3teX205M2fee9SwjAADwy2XzBd1HdivxveiNUAKJi08UwebA3BSJvrKtdlJxarSxfHic6L7wdj4wJyD7VtfeHxdpfMwY7s0RE2/6o/UciEHbZnfaHW3uhXpzWosJd74TcOC9cVb3J8JDDPHEteouhr0krKcKC8ih1TUzitOMvejktGyRnOjVLzdFoiS3uFUTuvpPoF424lJy/ZnvaWnvXt96UKX8NCBY5PSd9yxJzHqqMhvfPbeqf3V2rDwBsqgYfekJun3rqcaajDi1J/fc7rl+4SWU9v/8hledH+MKcTJ9as+cj/kiJ7vbpI/cRCs5tuu8mWVp5gZaaJw4Z8U+PtUjAAD8ctH+cnPmwpGdD2cmGAfRcDyhUSK13fAjVy+d+WK4uSfUFInuubjnnbGm8FJadhV1z2h9jZaG+eaJlePb5xi3HRrlFcVTN9xotBhiqhvR9s9RYZ6vw0No765m+ikapAOeH/LPty24OTcqwrjPLbtpG1/82nqC+gY5+acVlSM65vBJfEVEYqFYed2NhzoVxOgnEG+aRH/nra3O+h+6KIKCo8U5y/bwEa1nzAOX91+VHhtmrEdeezH93g9qjRZ3eG90SW3ll0HBIcKbmCrKek/7+H1NO6MjlW+Y3ee5CI+5B5xSJM7ZeNj1BNyadqJqVu8KvR9n4Iwb+HvaBhE/PD12XOdCf//qyese1hsAAOCXivbulpohbXL9A5svo1jk10zb9jwJbN9FHa6ONvdMmyLRbXUjN+Ykxz3ri/CcatVj8qmXtMYlqt2VkFNdaEjUExkjUmvX+k+wzHs1F4zt59s4tTg/1xcypu3wJYPMpgY5dPW4m1MiTfkUdRErn/+m8fugaUkXDyt/ky7SHlKUyB6y8oCmHWpblRelf9TcJIl+eFtNTUnSabooopMLxPQdR1yPkm0ql9QWP0t/9PWoHr3kU3osAh69zBK9a9XEwUEhiWOmrv91t6CM9tGr632/3BSe3zX30hK5txgSJirOXXvIaHGiaZ+Uz+hdrm94cDqOXfGO3tAA2v/8rnZ4e/laCxdDFm3/g9ECAAC/UMSJ63sPaZ0lPDGJIrGky/19F+3vYzYFbVvQc1tzJCoZUxSVlT10Nk+o0OjPTD596KLxldnGR8CRsRni3Gsf3my0nBkLB+Q85/EYg3pu53HfPKJpfPBRg7B8bquruSM1zth7za0e/cUWIdLFwaD8ji19eq0pEn3m+n7Ti8zvkhMLe/1n3UlRyXXtsfVppWlePkt/JxJ0p7ILdjT68bIQT+eOqUrn38GK4LBIUTXzpj1Gy8+LEDuSJ3TO+pQvclIqhny39mMtT290gTdyVk5s/ypf5Hhb9vhq80datd7owr5F3TYkRxkbOGHx+WLmjj9fYbQAAMAvlP+8dVePFQvnPJw64soas+Rn+/weW89Eos1h27y+98WatxGf11GsfeKTZh9Ry9CAHrluQuvVGQmGDD2RyaLD/Nsb/W3nq3svnltdmKwvE5ddIebvfUX/+Fe7Z1C7joVxer0pEr3nitF7feZH2QU10/+6be343j2L4+/KSvb+MyrM/GlOsEeExSR+ldmqw0s1U1cvpPvseuCReGJq+27mT2Wi43PEgCse0I/e1bQ3E2srQmo7FiXdERMZ+gqVXvFExr9SWj3oQJ8pa6Y0ZaMlEHuWDr7bG24cjRudlCtmbnmi0Q2aYwdX1XUsMB6/4JBwWvdpR6956hOHSHcvqB7TOivKf9BZTrdJny37KvBH8wAA8F/Pb4Tgn0q48nNL9Munp1f0KUlRR+f2nHGU7k+DB89Y+eDw6siChATfzp3LWs2f0H/hiO4lR5OijQOUQsO8orp2yZvPaFqq0dsdcXRp/uiOOfr3nqFRyaLzhbfsNFqo8Jv+lU2VKMnQs2Zyp6f0n3AEB4v8lqX/m5+eoC/bUCLi0kSHcy547cIjWib9b+P9vZPHts4yv9dNrxLb3tKWvLBpcq8B7XM/jKv3m0uZaF+aSG477Jll+9/rSP83G3F8Y+XA8nT/R7MFfWe/f5L2yPXGANC6h+xcNOTWkgy1vvGZhd+UdB18N12eFBbmmVxdlv5YbpI84jtYJBZ3OTlg/WP+TzwAAOCs5OeUKB/ZObt34Wvyt4PRaWVizNZnJhutjXPzlKyLEmNCP4+JifrOa35EyPFlFYvKUSs30l5ZwLl5qT1q+ajyp40ZlTyiqnbxX76yHLTUHIlq2nct5gys9O9lyUT6UkRqTuEHdPkxTou0+G+jItR9ZaHkdpv49v2n7EcQv37gyi2lScb3xNEF3cT9j953vEeLRP9ynlA1aUKE3Ms1U1A17N+XHHh3CF1uFldNLL0nMsS4jujUEtHv+senGy1N49BNMyb0b5d/1Fvv/lgTGZfyfX6X2r3T9v61iP4HAICzm59LoiSwjI0Lh76eaP60JTQqSfS88OZmHc26YUa7Q6GWAVomPr1YdBg6cd+ASx9o8Ls55o7Fva/OTTZ+zpJY3OfU5pe/6We0GDRLou8uLOpbbnykyQkNjxEtu459YcjizUNpT82ndyKObJmRd9G4HnVdSzN5Tlm9b0hItKg6d81TegeTJ28+/8a8WOO+RSRlitbFxlSCkd5UUdJ10PPJVcPH0f985G1xTWXWwqr82DciQ81JHihFNTNO7vh703/ao721qd2AslT/xBctB8w/Rve7wZ+q1If6hteN7TynY0vfG/J3sm4Jj03+od3g6Y/M2flUowd7AQDAL56fQ6I04KZvXHDOawnmhAY852vF8CXPfy0En5Wlyaw9f+RrWUUVPF3e9vT0pP0t0xO/iItSe2jx2aWibNJVF3Pf+rz3wPIxvcrS9X6RSQXi3E2PXm60KJoj0Q8OLprYPtf7aUJMhAiN8InuEy5/jtazwaNpv3ruhv5DW2d9TRf164/KqhSj9hz3S/zha8bfmBlrnyM4Ka+dmHnN/h10vbTzbkeIw+lXTu/zerT5+9ggT6wYcfl+/ji1Sey6ZOA9seGG/MKTCkXPdX+YYbQ0jvbBvZ2n9yl9I8lrfPzMe9ch0fHfxWW0PEz/bw8JCdmZkxzzQWykkqs3q1Sct37/NlqXMz4rEAAA/NfzU0tU055LW3Fu79d85oDNH0sWD5z2/NZGfvvpxrx5q2OtQhEv7UheNLz10pIsr/97vdj0MjF16x8X6h1MtNNPl0/uUagfgRocEivKJ1zhugfcHIn+/vrzYiYOnZgwvWdJbWxW5diDjfwchXlgRZelGbGG9II9YWJQ3fYnjBanRD2RPtF17vbb9cYG0LRHM0e3S/NPkJBZPfarQ5qWojcGQHx1dcKo6gzj962U1oNmf6tpWpre2AhCvOerG1n+Tpicu9cTITLaj3qyfPqGCqOHgfhgdeS18wctqi6M/4L/5SS0aCeGrf2t60YOAACcFfyUEtUOVWeP65H7WrjHGHBDI+JEu3MufOHuRn6C0lzuu2pEXXGW8dMUTvngWd++ah5gRNINuWF6j8PG2VCCReuBc/9OwnCdFlC8Pqqkk/8nLkli0BUP2mZS+rFopw+1q+2oJpbP6TPd/xvLxzZMvjE7Rkk0p7r21MNNmDjh15f23ZFgfj/sze0glv3+46lGS8O8vOuCZYWJxm2FRSeJc1bds9VoaZwnNo1fmZNo7IEGe0JF+aglbxgt7ryyuUd1t+J4/be0nLxO404/8rUo0RsBAOBs46eS6DO3Lx4zqG3Gx/IgouDoZNF3yhWPkcB+UoEyJErPNTN7viGnK4zObCsW3vuufpDMniVdLy40vwf1ZZRpk6+7cxld5iNQ+beQtmye3mpw2zzjiNLwmHjRcfJaPk+o3pbfbkjepnd+3M9JaN1jZvTOOkoX9dso6Dn5u7c14zRjr91z+c2lSeb0iZSqUZfwRBCN8rf76qa2zTTWL9qXIyZvfPxao8Ud3qhYM6nLiyHm7WS0HSS2n9CafNRs3ZDiF+iPvqyvoOu/r3lb66w3BOD+9aN3JUQbn0REJxWIGTuf/Uk3TgAA4L+Gn0Kiu+pqFlS0SPD/jCUuo1Bk1S7/WX9k/6et01YXmNMYRsSki3FXPahPir7hwoFfco3jCdX32PhjTJ5v1hGS8PdSxJzgYA+vg96W23bIf7b+o3FhNEbdiDZ+CZV3nSye1LT+XH//1xNHtM5We6LD5215i+uNod1eVta+wBB/RGy86Ll43xqjxR3t5OMVo6vz/c9N2chl/F2u4ztXNzTt7YwxXdL0CSE4uQPn/VlvaATt4x29BrWWZ9sJFkMW3NKk5QAA4BfHj5XormVj97TOVD/NiM6p/HrK2rtX6I0/I+8/uPbyqtR4/TZDo2JE5flb9D2yjQuH+mfj+THJrxwudvxT41N9/SjOr8k+Qn+M6+w5+eRxTdO/S9SOXtuhX4U6uffAWTcG/JhUcvKOHlVV+cYebJQ3RQxbffAqo8WdF24eeUFxmtE/JCZD9Fz1UJO/o9S+f3L45B5l/vs4YO7G5/SGRtC0j3vNHtTWv1z3KesDnpAcAAB+sfwYiW6ZP3h3rmVS+6x2/b5ss+LRZu29fXJ9UGp5RvCVpbm+R8OiEo4OXbH/SrMpIK/umbesJNk8A0tMihi+6l59T/SmBUP8R8T+mOS3O0fs+LvoTpd1hpZ75rYtTNudEh12NL/r5Oe+1bQss6lBNO394ondC76ji/p15tXM9H8nqmnfZk7vlec/SCij23nv8kevemMAjh5YfEl5iiHFiIQiMW3HS0uMFneumVK5X54+La11v+83H9d6GC2No2kvdJ3QNd///Wb7iat5rt9GofXuOaN/a30ZTv9ZN7ymNwAAwNnGmUiUB/tfLa/dnecXqEe06zfzy40v/ovnj20Wp09cWzW8g9ojaz926T/p+hv9/eLGaW3viA43z0KSViYW7D++gOubFgzhvcdeTcmkHhnnl2Qa6xAWHSdKBs+6U7blVw7rtelzLY4u6ywa0cZ/4uy00j5i+YuNf694YteYsWXphvCCQyLE4MW3PmK0GNwwu/dz8jvkhPwOYt3TX04xWhrmtsUDfxsTZjxfKWU1YskRzXZuViuapnln9Mhhcev9K4bP50nuI/XGJsAf+07qkfUhX+RkdBn9rw+aMMPR94em1lTlGQdsBYdGi4GLdx8wWgAA4CzjTCT68HWjL6zMMz5KDQ4KEe1HLPjyj//Smi1QhgZq34oJ1f5zdCbkt9dWP/7ZRL2xAbR3N3cb0CbDv4eX06H231sCTKLeENpXM1t2LjKPzo1LEkOv+sMqo8XJ/pWDd8VHmD9XCY0V3eZsDXieTBbYZeM7vmXMlhQk4lp0EOP2f2AT76t3TJtRmmoeXBTsEV2nXvG20eKOdvpgm1FdWnxPF/VlWg+tO0634xd9fbQ3l5f1a23MzxscGi46zNxwkB7vZp315aaZ1XdHmPMFh3qTRffF+wN+B8ssGpR1MMI8QUAUbeCM2vXGaKMFAADOMporUe3I6pbDK9K+pYu0TLBILuv3tz1/c57MuTn84cZzV2XGqanyEqpGHO/yjPucuJ8+OrtoVIfEN0NNOUV4U8Wwlft2Ga3Nozm/E/3u7Tv613YuUPcxv0rUbfv9DXpjPVig66ZWbc1IMI6i5fN/dpl8JZ/A2zZNIf0fMa9/i/foot4vnCTV7rw1G/XGemjaM6kLh1e8FG7KKSK5SPRa9/tpRqs7f3lgVV1lhnkQkjdPXLD1Kf95XJvKZy9uGjGgMttYD4o3r/33k9ftn6c3unDZ+NLNSV41IUbp4Nlfvd3AT4wAAOAXT3MlesuCng+E+49oDRbB0Yn8vR7PXMNHoTae8JgXgvos1T96ldDeUej8QUVHQs3fl/JeWUxW6Ucl3cesHjZrFv8kJPe8AUUV3UvjVla28Fm+8wwWJQPnHiU7ZdP/zaY5EuWPNrcv7L01OUbNyhOfXiQyynvf3mncIp7Hlqfgyx1QlTWrV2X2kfhotVFQ3GvSf3Yfdz992Ft7pvfrkB/j36sOjY4Xma27H+42Zv7syMhI3rvOnTKs86KadnkfRZjT/nlCQkXZ8MVH6D4F/Gh2b137Zek+4wjgyOy2YvSeD4cZLU2H91w3zem+JzHGeI1wfCkFoqh60MNBJYMG0P+5Pp8vf1rfitntC3xPei2T59NjIxbtf71Z8/MCAMAviuZIVPvLJZkD2yTqZ0Q544R7RVDfSzbRZRvaM7WpQyvjXg4PVYNwSFikCIvQf+h/OjzUo4VZ5o71UFt255FHRxz8Iof+PyOaI1HJ1OrgrUkx6j5ywiL171X5AJzTUeZjyQkO8oicNn2/n7HjtXPo/wbZNDpkQFmaxy9STmSMfr/064y0TvjuCRPhZQNerm1gT93KhimtdkSHG8tlktBWHNU6GC3NZ0bPhN1JsdaJ9SnGJPmng4ODT3st0zFyfHzKuS2P6Ad7AQDAWQtJ9FcxkcbAH1/aS4x6Tmvw7Bt/eXD5og55xhGxZxxdopfeQpcdaJ8sTp07usvD+Sk+QdJ0XZ5/++nLbCnyu5+7a3cTjpANhHZPvw5dWhnfiUbGJZFE73L9KLU+Kye2v6403fdtpHmAjzPB+gnQfa36PlR351tNOhp238oBgwa3b3EiJc78jtQRj4hOSBfl/ac83PbexgXK3LJwxOf0R1++ot9cQXvsPfWGM2Td7P6bK/KTvw0zzwTjlkjaGEkv7/1O56V7h9P/AABwdrN9QbfhUREhfLDIGl9Rtysnvt7wHLfHH7x6aJsUr973jBMWsyao96UD6XKD/HbjnMHVRSlrWmZ4+feFx/R4Qo4FJeTen9yy6vKxa3a31zv+SLQ7B2Z0KDTWJ8KbsKZm2X7bWV4C8fjGOcVDqlquLs+LfzA0xGPcR0pCTumxkqou2wrHXRlwHd3g70zXTu4zqzQ5cktybKi6zuySY+Wd+m3vf9HWwXrHJrJ+ah/+2Fxfv6pzFqw5pWlnvNcuObZzfotOeUHzqstyH4n2qPWOik875sssv7nvlMvOf0mIaL0zAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALgSFPT/AOCI2c85KKSxAAAAAElFTkSuQmCC" alt="" style="height: 50px;">' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 11px;font-weight: 700;">' +
      '                            CUSTOMS DECLARATION' +
      '                        </span>' +
      '                    </td>' +
      '' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 9px;font-weight: 700;">' +
      '                            May be opened' +
      '                            <br> Officially' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <h4 style="margin: 0;">' +
      '                            CN 22' +
      '                        </h4>' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="3">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Designated Operator' +
      '                            <br>' +
      '                            <br>' +
      '                            </h3>' +
      '                    </td>' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">Important!</span>' +
      '                        <span style="margin: 0;font-size: 7px;">' +
      '                            <br> See instructions' +
      '                            <br> on the back' +
      '                        </span>' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="1" style="width: 24px;">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;">' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Gift' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1" style="width: 24px;">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;">' +
      '                    </td>' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Commercial Sample' +
      '                        </span>' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="1" style="width: 24px;">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;">' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Documents' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1" style="width: 24px;">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;">' +
      '                    </td>' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Returned Goods' +
      '                        </span>' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="1" style="width: 24px;">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;">' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Sale Of Goods' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1" style="width: 24px;">' +
      '                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;">' +
      '                    </td>' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Other (Please Specify) ______________' +
      '                        </span>' +
      '                    </td>' +
      '' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Quantity and detailed description' +
      '                            <br> Of contents (1)' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Net' +
      '                            <br> Weight' +
      '                            <br> (2)' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Value and' +
      '                            <br> currency' +
      '                            <br> (3)' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            H S tarrif' +
      '                            <br> number' +
      '                            <br> (4)' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Country' +
      '                            <br> of origin' +
      '                            <br> (5)' +
      '                        </span>' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '' +
      '                        <td colspan="1">' +
      '                            <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                                <br>' +
      '                            </span>' +
      '                        </td>' +
      '                        <td colspan="1">' +
      '                            <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                                <br>' +
      '                                <br>' +
      '                            </span>' +
      '                        </td>' +
      '                        <td colspan="1">' +
      '                            <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                                <br>' +
      '                                <br> ' +
      '                            </span>' +
      '                        </td>' +
      '                        <td colspan="1">' +
      '                            <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                                <br>' +
      '                                <br> ' +
      '                            </span>' +
      '                        </td>' +
      '                        <td colspan="1">' +
      '                            <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                                <br>' +
      '                                <br> ' +
      '                            </span>' +
      '                        </td>' +
      '                    </tr>' +
      '' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="2">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Total Weight in kg(6): 0.700 Kg' +
      '                            <br>' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            Total Value (7)' +
      '                            <br>' +
      '                        </span>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <h4 style="margin: 0;">' +
      '                        </h4>' +
      '                    </td>' +
      '                    <td colspan="1">' +
      '                        <h4 style="margin: 0;">' +
      '                            <br>' +
      '                           ' +
      '                        </h4>' +
      '                    </td>' +
      '                </tr>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="5">' +
      '                        <span style="margin: 0;font-size: 7px;font-weight: 700;">' +
      '                            The undersigned, where name and address are given on the item, certify that the particulars given in this declaration are' +
      '                            correct and that this item does not contain any dangerous article or articles prohibited by legislation' +
      '                            or by postal or customs regulations' +
      '                            <br>' +
      '                            <br> Date and sender?s signature (8)' +
      '                        </span>' +
      '' +
      '                    </td>' +
      '                </tr>' +
      '             </tbody>' +
      '         </table>' +
      '    </div>' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '    <div style="width: 75mm; height: 105mm; margin: auto; overflow: hidden;padding: 0px">' +
      '        <table class="details">' +
      '            <tbody>' +
      '                <tr class="pi_heading1">' +
      '                    <td colspan="5">' +
      '                        <h6> Instructions</h6>' +
      '                        <span style="margin: 0;font-size: 9px;font-weight: 700;">' +
      '                            To accelerate customs clearance, you must complete all applicable fields, and fill in this form in English, French or in' +
      '                            a language accepted by the destination country, If the value of the contents is more then 300' +
      '                            SDR, you must use a CN 23 form, you must give the sender?s full name and address on the front' +
      '                            of the item.' +
      '                            <br>' +
      '                            <br> For commercial items, it is recommended that you complete the fields marked with an asterisk' +
      '                            (?), and attach an invoice to the outside, as it will assist customs in processing the items.' +
      '                            <br>' +
      '                            <br> Select a reason for export, (?Gift? is not an acceptable reason for export for commercial items.)' +
      '                            <br>' +
      '                            <br> (1) Give a detailed description (generic descriptions such as ?cloths? are not acceptable),' +
      '                            quantity and unit of measure for each article, e,g. two men?s cotton shirts.' +
      '                            <br>' +
      '                            <br> (2),(3) Give the weight and value with currency for each article, e.g. CHF for swiss francs.' +
      '                            <br>' +
      '                            <br> (4) The HS tariff number (6 digits) is based on the Hannonized Commodity Description and Coding' +
      '                            System developed by the World Customs organization.' +
      '                            <br>' +
      '                            <br> (5) Country of origin means the country where the goods originated e.g. were produced manufactured' +
      '                            or assembled.' +
      '                            <br>' +
      '                            <br> (6) (7) Give the total value and weight of the item.' +
      '                            <br>' +
      '                            <br> (8) Your signature and the date confirm your liability for the item.' +
      '                            <br>' +
      '                            <br> Note ? It is recommended that designation operation indicate the equivalent of 300 SDR in their' +
      '                            national currency' +
      '' +
      '                        </span>' +
      '' +
      '                    </td>' +
      '                </tr>' +
      '            </tbody>' +
      '        </table>' +
      '    </div>' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '' +
      '</body>' +
      '' +
      '</html>';


    var myWindow = window.open('', '', 'width=200,height=100');
    myWindow.document.write(myvar);
    myWindow.focus();
    myWindow.print();
  }
  myFunction() {
    this.router.navigate(['/orders'])
  }
}
